import { render, staticRenderFns } from "./DocsExample.vue?vue&type=template&id=60ba86e7&scoped=true"
import script from "./DocsExample.vue?vue&type=script&lang=js"
export * from "./DocsExample.vue?vue&type=script&lang=js"
import style0 from "./DocsExample.vue?vue&type=style&index=0&id=60ba86e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ba86e7",
  null
  
)

export default component.exports